import { ClearIcon, EnterKeyIcon, MagnifyIcon } from "../Icons";
import './index.css'


interface InputSearchProps {
  label?: string,
  name: string,
  value: any,
  placeholder?: string,
  onChange: (event: any) => void,
  onSubmitSearch: () => void,
  onResetSearch?: (event: any) => void
}

export default function InputSearch({ label, name, value, onChange,
  placeholder, onSubmitSearch, onResetSearch }: InputSearchProps) {

  const onKeyPress = (e: any) => {
    if (e.key === "Enter" && value !== '') {
      onSubmitSearch()
    }
  }

  const body = (
    <div className="input-search-box">
      {(label) && (
        <label className='input-search__label'>
          {label}
        </label>
      )}
      <div className='input-search__field'>
        <input
          value={value}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyPress}
        />
        {(value === '') ? (
          <span className='input-search-icon'>
            <MagnifyIcon />
          </span>
        ) : (
          <span className='input-search-icon'>
            <EnterKeyIcon className="input-search-icon-enter" />
            <ClearIcon className="input-search-icon-clear" onClick={onResetSearch} />
          </span>
        )}
      </div>
    </div>)

  return (
    <>{body}</>
  )
}


